import { AutomaticActionActionTypes, AutomaticActionData, AutomaticActionsTypes } from "./automaticActionTypes";
import { AutomaticActionEnum } from "@/main/services/enum/AutomaticActionEnum";

export function getAutomaticAction(): AutomaticActionActionTypes {
	return {
		type: AutomaticActionsTypes.GET_AUTOMATIC_ACTION,
	};
}

export function saveAutomaticAction(data: AutomaticActionData): AutomaticActionActionTypes {
	return {
		type: AutomaticActionsTypes.SAVE_AUTOMATIC_ACTION,
		payload: { data },
	};
}

export function resetReducerAllByAutomaticActionEnumAction(action: AutomaticActionEnum): AutomaticActionActionTypes {
	return {
		type: AutomaticActionsTypes.RESET_REDUCER_BY_AUTOMATIC_ACTION_ENUM_ACTION,
		payload: { action },
	};
}

export function resetReducerByIdAction(action: string): AutomaticActionActionTypes {
	return {
		type: AutomaticActionsTypes.RESET_REDUCER_BY_ID_ACTION,
		payload: { action },
	};
}

export function resetAllReducerAction(): AutomaticActionActionTypes {
	return {
		type: AutomaticActionsTypes.RESET_ALL_REDUCER_ACTION,
	};
}
